import { createImageSliderComponent } from '@vfde-brix/image-slider';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountImageSlider = () => {
    const elements = document.getElementsByClassName('brix-image-slider');

    for (let i = 0, x = elements.length; i < x; i += 1) {

        const containerElement = elements[i].parentNode as HTMLElement;
        createImageSliderComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

    }
}
